module.exports = __webpack_public_path__ + "img/hotel-britania.f931ee61.jpg";